<template>
  <section class="dd-effects__hero dd-wall-card">
    <div class="dd-effects__hero-main">
      <slot name="heading"></slot>
      <slot name="body"></slot>
    </div>
    <div v-if="$slots.actions" class="dd-effects__hero-actions">
      <slot name="actions"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EffectHeroCard',
};
</script>
